import { render, staticRenderFns } from "./DashboardSPM.vue?vue&type=template&id=8a12482a&"
import script from "./DashboardSPM.vue?vue&type=script&lang=js&"
export * from "./DashboardSPM.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSPM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports